import { useEffect } from "react"; // eslint-disable-line
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";

import observeDoc from "api/observeDoc";
import observeSection from "api/tables/observeSection";

export default function useObserveActiveFloorplan() {
  const dispatch = useDispatch();
  const businessUid = useParams().id;
  const uid = useSelector((state) => state.business.business.activeFloorplan);

  useEffect(() => {
    if (!uid) return;

    dispatch({ type: "ADD_FLOORPLAN_LOADING", uid });

    let unsubs = [];
    const unsubscribeDoc = observeDoc(
      `floorplans/business/${businessUid}/${uid}`,
      (data) => {
        if (!data) {
          dispatch({
            type: "ADD_FLOORPLAN_ERROR",
            uid,
          });
        } else {
          dispatch({
            type: "ADD_FLOORPLAN_SUCCESS",
            payload: { uid, data },
          });
          const unsubscribers = data.sections.map((sectionUid) =>
            observeSection(businessUid, sectionUid)
          );
          unsubs = [...unsubs, ...unsubscribers];
        }
      }
    );
    unsubs.push(unsubscribeDoc);

    return () => unsubs.forEach((el) => el?.());
  }, [businessUid, uid]);
}
